import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { MediaBaseUrl, HOST_URL, EXPIRE_POST_UPDATE, SOCKET_CLIENT_URL, UPDATE_USER_PLAN, SW_LOGO } from "../actions/api";
import { getTwitterCode, getFbCode, getVimeoCode, getTiktokCode, getGoogleCode, getSlackCode, getInstaCode, getThreadCode } from "./auth";
import { toggleAddFeedsSection } from "../actions/show_modal_Action";
import { yammerCode } from "./auth";
import md5 from "md5";
import $ from "jquery";
import { toggleAddFeedsSection_D } from "../actions/showDisplayModalAction";
import axios from "axios";
import store from "../store";
import ReactHtmlParser from 'react-html-parser';
import { ENCRYPTION_KEY, UPPY_BUCKET_URL } from "../actions/constant";
import crypto from 'crypto-js';
import moment from "moment";
import io from 'socket.io-client';
import HttpClient from "../actions/http-client";
import { getProductAndPlanDetails } from "../actions/product_details_action";
import { getUserInfo } from "../actions/loginActions";
import { ErrImg, ProductPlaceholder } from "../app/CommonComponents/AssetsHelper";
import { MOD_PST_FILE_UPDATE } from "../reducers/keys";
import { Modal } from "react-bootstrap";


export const fadeOutEffect = (fadeTarget) => {
  if (fadeTarget && fadeTarget.style) {
    var i = 0;
    fadeTarget.style.opacity = 0;
    var k = window.setInterval(function () {
      if (i >= 10) {
        clearInterval(k);
      } else {
        fadeTarget.style.opacity = i / 10;
        i++;
      }
    }, 25);
  }
};

export const customClass = {
  confirmButton: 'btn btn-primary m-0 px-4',
  cancelButton: 'btn btn-outline-dark me-2 m-0 px-4',
}


export const secondsToTime = (secs) => {
  var sec_num = parseInt(secs, 10); // don't forget the second param
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  var seconds = sec_num - (hours * 3600) - (minutes * 60);

  if (hours < 10) { hours = "0" + hours; }
  if (minutes < 10) { minutes = "0" + minutes; }
  if (seconds < 10) { seconds = "0" + seconds; }

  return hours + ':' + minutes + ':' + seconds;
}


export const isDayTime = () => {
  try {
    const hours = new Date().getHours()
    const isDayTime = hours > 6 && hours < 20
    return isDayTime;
  }
  catch (ex) {
    return true;
  }
}



export const kFormatter = (value) => {

  try {
    var newValue = value;

    if (value >= 1000) {
      var suffixes = ["", "K", "M", "B", "T"];
      var suffixNum = Math.floor(("" + value).length / 3);
      var shortValue = '';
      for (var precision = 2; precision >= 1; precision--) {
        shortValue = parseFloat((suffixNum != 0 ? (value / Math.pow(1000, suffixNum)) : value).toPrecision(precision));
        var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g, '');
        if (dotLessShortValue.length <= 2) { break; }
      }
      if (shortValue % 1 != 0) shortValue = shortValue.toFixed(1);
      newValue = shortValue + suffixes[suffixNum];
    }

    return value ? newValue : 0;
  }
  catch (ex) {
    return Math.abs(value) > 999 ? Math.sign(value) * ((Math.abs(value) / 1000).toFixed(1)) + 'k' : Math.sign(value) * Math.abs(value)
  }

}


export const kFormatter_new = (value) => {
  let result = '', suffixes = ''
  try {
    if (Math.abs(value) >= 1000000000000) { result = (Math.abs(value) / 1000000000000).toFixed(1); suffixes = 'T'; }
    else if (Math.abs(value) >= 1000000000) { result = (Math.abs(value) / 1000000000).toFixed(1); suffixes = 'B'; }
    else if (Math.abs(value) >= 1000000) { result = (Math.abs(value) / 1000000).toFixed(1); suffixes = 'M'; }
    else if (Math.abs(value) >= 1000) { result = (Math.abs(value) / 1000).toFixed(1); suffixes = 'K'; }
    else result = parseFloat(parseFloat(value).toFixed(2)).toString();
    return parseFloat(parseFloat(result).toFixed(2)).toString() + suffixes
  }
  catch (ex) { return parseFloat(parseFloat(value).toFixed(2)).toString(); }
}

export const updateURLForIframe = (url) => {
  if (url && url.includes('youtube.com')) {
    const urlSplits = url.split('?v=');
    if (urlSplits && urlSplits.length && urlSplits[1]) {
      url = `https://www.youtube.com/embed/${urlSplits[1]}`;
    }
  }
  else if (url && url.includes('vimeo.com')) {
    const urlSplits = url.split('/');
    if (urlSplits && urlSplits.length && urlSplits[urlSplits.length - 1]) {
      url = `https://player.vimeo.com/video/${urlSplits[3]}?autoplay=1&loop=1&autopause=0`;
    }
  }
  return url;
}


export const convertIntToBool = (value) => {
  if (value) return Boolean(value)
  else return value;

}

export const getTimeTypeSecondToTime = (secs, type) => {
  let dataTime = secondsToTime(secs);
  let acrtualTime = dataTime.split(':')
  if (type == 1) {
    if (acrtualTime && acrtualTime.length) return acrtualTime[0];
    else return 0;
  }
  else if (type == 2) {

    if (acrtualTime && acrtualTime.length) return acrtualTime[1];
    else return 0;
  }
  else if (type == 3) {
    if (acrtualTime && acrtualTime.length) return acrtualTime[2];
    else return 0;
  }
}

export const getHostname = (url) => {
  if (url && url.length > 0) return new URL(url).hostname
  else return ""
}

export const getSecondsFromTime = (time) => {
  let actualTime = time.split(':');
  let totalSeconds = (+actualTime[0]) * 60 * 60 + (+actualTime[1]) * 60 + (+actualTime[2]);
  return totalSeconds;
}

export const getPosition = (partitions, currentSceneContent) => {
  const getPartitions = Object.keys(partitions).map((item) => ({ position: item, name: partitions[item] }))
  const filterData = getPartitions.filter((item) => item.name == currentSceneContent.name);
  return filterData;
}

export const loaderCircleStyle = { padding: 1, color: '#545454', fontSize: 10 }

export const GET_HEIGHT_WIDTH = (cssStyle, position, layouts, mixContentType) => {

  const actualLayout = layouts.filter((item) => item.id == mixContentType)

  if (actualLayout && actualLayout[0]) {
    const currentHeightWidth = GET_DYNAMIC_HEIGHT_WIDTH(cssStyle, position);
    const actualDefault = GET_DYNAMIC_HEIGHT_WIDTH(actualLayout[0].css, position);
    if (actualDefault && Object.keys(actualDefault).length) {
      if (parseInt(actualDefault.height) > parseInt(actualDefault.width)) {
        return { width: currentHeightWidth.width, height: 0, label: "Width" }
      }
      else if (parseInt(actualDefault.height) < parseInt(actualDefault.width)) {
        return { height: currentHeightWidth.height, width: 0, label: "Height" }
      }
      else {
        if (mixContentType == 1) {
          return { height: currentHeightWidth.height, width: 0, label: "Height" }
        }
        else {
          return { height: 0, width: 0 }
        }
      }
    }
    else {
      return currentHeightWidth;
    }
  }
}

const GET_DYNAMIC_HEIGHT_WIDTH = (cssStyle, position) => {
  const cData = cssStyle.split("#zone");

  var height = ""; var width = "";
  if (cData && cData.length) {
    cData.map((item, index) => {
      const trimContent = item.trim()
      const firstValue = trimContent.charAt(0);
      if (firstValue == position[0].position) {
        const replaceValue = item.split(";")
        if (replaceValue && replaceValue.length) {
          replaceValue.map((rItem) => {
            const getHeightWidth = rItem.split(":");
            if (getHeightWidth && getHeightWidth[0] && getHeightWidth[0] == "height") height = getHeightWidth[1].replace("%", "");
            if (getHeightWidth && getHeightWidth[0] && getHeightWidth[0] == "width") width = getHeightWidth[1].replace("%", "");
          })
        }
      }
    })
  }
  return { height, width, }
}

export const REGEX = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

export const AUTHOR_IMAGE = (author, nerworkColor) => {
  const name = author.replace(/[^a-zA-Z0-9]/g, "");
  const color = nerworkColor.replace("#", "");
  return `https://ui-avatars.com/api/?name=${name}&length=1&background=${color}&color=fff`;
};

export const checkIfStringHasSpecialChar = (_string) => {
  let spChars = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
  if (spChars.test(_string)) {
    return true;
  } else {
    return false;
  }
};

export const validURL = (str) => {
  var pattern =
    /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
  return !!pattern.test(str);
};

export const TOAST_DISMISS = (dismiss) => {
  toast.dismiss();
};

export const checkWordCount = (_string) => {
  if (String(_string).length < 3) return false;
  else return true;
};

export const removePopup = () => {
  $(".modal-backdrop").remove();
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const GET_FIRST_LETTER = (string) => {
  if (string && String(string) && string?.length > 0) return String(string)?.charAt(0)?.toUpperCase();
  else return string
}

export const TOAST_LOADING = () => {
  const load = toast.loading("Please Wait...", {
    position: "bottom-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

  setTimeout(() => {
    toast.dismiss(load);
  }, 1000);
};

export const TOAST_UPDATE = (toastId, type, msg) => toast.update(toastId, {
  position: "bottom-right",
  render: msg,
  type: type,
  isLoading: false,
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
});

export const TOAST_SUCCESS = (msg) => {
  toast.success(msg, {
    position: "bottom-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const TOAST_ERROR = (msg) => {
  toast.error(msg, {
    position: "bottom-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const TOAST_WARN = (msg) => {
  toast.warn(msg, {
    position: "bottom-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const SWAL_FIRE = async (attr) => {
  const result = await Swal.fire(attr);

  return result;
};

export const emailValidation = (email) => {
  const isallEmailvalid = REGEX.test(email.trim());
  if (isallEmailvalid) return true;
  return false;
};


export const createFeed = (dispatch) => {
  dispatch(toggleAddFeedsSection(true));
  dispatch(toggleAddFeedsSection_D(true));
};

export const GET_NETWORK_ICON = (networkId) => {
  switch (networkId) {
    case 1:
      return "twitterX";
    case 2:
      return "instagram";
    case 3:
      return "facebook";
    case 4:
      return "google";
    case 5:
      return "pinterest";
    case 6:
      return "flickr";
    case 7:
      return "youtube";
    case 8:
      return "vimeo";
    case 10:
      return "linkedin";
    case 11:
      return "tumblr";
    case 12:
      return "rss";
    case 13:
      return "star";
    case 15:
      return "workplace";
    case 18:
      return "instagram";
    case 19:
      return "yelp";
    case 20:
      return "slack";
    case 21:
      return "yammer";
    case 23:
      return "airbnb";
    case 25:
      return "soundcloud";
    case 26:
      return "giphy";
    case 27:
      return "tiktok";
    case 28:
      return "tiktok";
    case 29:
      return "onsite-upload";
    case 30:
      return "onsite-upload";
    case 31:
      return "bluesky";
    case 32:
      return "threads";
    default:
      return "";
  }
};


export const GET_MEDIA_NAME = (postFile) => {
  if (postFile && String(postFile)) {
    var fileName = unescape(postFile);
    fileName = fileName.split('/').pop().split("/").slice(-1).join().split(".").shift();
    return fileName
  } else {
    return '';
  }
}

export const stripTrailingSlash = (str, wall) => {
  const update = str.includes("update");
  if (!update) {
    var my = str.split("/").slice(0, -1).join("/");
    return my
  } else {
    return `/studio/${wall.wallId ? wall.wallId : wall.params.wallId}`;
  }

};

export const baseUrl = (pathname) => `${MediaBaseUrl}` + pathname;

export const STRING_TO_URL_CONVERT = (string) => {
  try {
    var addString = string;

    if (string && string && string.includes("http")) {
      const urls = string.match(
        /(((ftp|https?):\/\/)[\-\w@:%_\+.~#?,&\/\/=]+)/g
      );
      if (urls) {
        urls.forEach((url) => {
          addString = addString.replace(
            url,
            `<a className="text_links_" target="_blank" href="${url}">${url}</a>`
          );
        });
        return addString;
      }
      return string;
    } else return addString;
  } catch (ex) {
    return string;
  }
};


export const HideAppsMore = (show = false) => {
  let root_appsMore = document.getElementById("root_appsMore");
  const closeBtn = document.querySelector('.truesense-close');
  if (root_appsMore) {
    root_appsMore.setAttribute("style", `display: ${show ? "block" : "none"}`);
  }
  if (show && closeBtn) {
    closeBtn.click();
  }
};



export const getCurrentUrl = () => {
  const { protocol, hostname, port } = window.location;
  let url = protocol + "//" + hostname;
  if (port !== "") {
    url += ":" + port;
  }
  return url;
};



export const getWallId = () => {
  if (localStorage.getItem('wallId')) {
    return localStorage.getItem('wallId')
  }
  const url = window.location.pathname;
  const array = url.split("/");
  let index = array.length - 1;
  if (url.includes('notificationId')) {
    index = 4
  }

  return array[index];
};


export const getWallIdNew = (redirectUrl) => {
  const array = redirectUrl.split("/");
  let index = array.length - 1;
  if (redirectUrl.includes('notificationId')) {
    index = 4
  }

  return parseInt(array[index]);
};


export const getWallID = () => {
  let path = '/studio/';
  if (window.location.pathname.includes(`${path}display`)) {
    path = `${path}display/`
  }

  return window.wallID ? window.wallID : window.location.pathname.replace(path, '').split('/')[0]
}


export const onDeletePop = (callback) => {
  Swal.fire({
    title: "Are you sure?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
  }).then((result) => {
    if (result.value) {
      callback();
    } else if (result.dismiss === "cancel") {
    }
  });
};

export const showAddAccountAlertNew = (item, type, detailedView = null, isBussiness = "") => {
  if (item && Object.keys(item).length > 0) {
    const network = GET_NETWORK_ICON(item.id == 18 ? 3 : item.id);
    const name = item.id == 18 ? "Facebook" : capitalizeFirstLetter(item.name);
    const isInstaDt = (item.id == 18 && detailedView != null);

    Swal.fire({
      imageUrl: baseUrl(`icons/social-icons-square/${network}.svg`),
      imageHeight: 40,
      imageWidth: 40,
      title: `<strong>${name}</strong>`,
      html: (item.id == 3 && detailedView != null) ? `<p class="font-weight-boldest text-dark my-3">Connect to Facebook to pull the content for this feed.</p>
          <p>We'll never post anything on Facebook.</p>
          <p>NOTE: Socialwalls does not access, store, or view personal information and passwords that you may use to connect your accounts.</p>` :
        `Connect ${name} to seamlessly pull the content for this feed.`,
      showCloseButton: true,
      showCancelButton: false,
      focusConfirm: true,
      confirmButtonText: `Continue with ${name} ${isBussiness}`,
      confirmButtonAriaLabel: `Continue with ${name}  ${isBussiness}`,
    }).then((result) => {
      if (result.value) {
        localStorage.setItem("networkId", item.id);
        localStorage.setItem("connectionType", type);
        switch (item.id) {
          case 1:
            getTwitterCode();
            break;
          case 2:
            getInstaCode();
            break;
          case 3:
            getFbCode(3);
            break;
          case 4:
            getGoogleCode();
            break;
          case 8:
            getVimeoCode();
            break;
          case 18:
            getFbCode(18);
            break;
          case 20:
            getSlackCode();
            break;
          case 21:
            yammerCode(createToken(21));
            break;
          case 27:
            getTiktokCode(27);
            break;
          case 28:
            getTiktokCode(28);
            break;
          case 32:
            getThreadCode(32);
            break;
          default:
            break;
        }
      }
      else if (result.dismiss === "cancel") { }
    });
  }
}

export const GET_FLITER_ID = (name, feedInfo) => {

  const ftr =
    feedInfo &&
      feedInfo.length &&
      feedInfo[0].networkTab &&
      feedInfo[0].networkTab.length
      ? feedInfo[0].networkTab.findIndex(
        (f) => f.feedtype.toLowerCase() == name.toLowerCase()
      )
      : null;
  return feedInfo[0]?.networkTab[ftr]?.filter;
};

export const ucFirst = (t) => t.replace(/(^|\s)[A-Za-zÀ-ÖØ-öø-ÿ]/g, (c) => c.toUpperCase());

export const windowRedirection = (URL) => setTimeout(() => (window.location = URL), 1000);

export const windowOpen = (URL) => window.open(URL, "_blank");

export const ADD_SCRIPT = (url) => {
  const script = document.createElement("script");
  script.src = url;
  script.async = true;
  document.body.appendChild(script);
};

export const WINDOW_ON_LOAD = () => {
  ADD_SCRIPT("https://widget.taggbox.com/common-assets/js/slackdown.js");
};

export const dateFormat = (data) => {
  const dateString = data;
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  const hour = date.getHours();
  const minute = date.getMinutes().toString().padStart(2, "0");
  const formattedDate = `${day} ${month} ${year} ${hour}:${minute}`;
  return formattedDate;
};

export const createToken = (networkId) => {
  const timestamp = new Date().getTime();
  return md5(`${networkId}${timestamp}`);
};

export const getInitialRoute = () => {
  return `socialwalls`;
};

export const getNavigate = () => {
  return window.location.pathname.split("/")[2];
};

export const getRoute = () => {
  return window.location.pathname.split("/");
};

export function titleCase(string) {
  const sentence = string.toLowerCase();
  return (sentence && sentence.length > 0) ? sentence.replace(sentence[0], sentence[0].toUpperCase()) : '';
}

// user.extra_data ek JSON string hai. Guest / website se aaye user ko onboarding nahi dikhana,
// isliye redux + localStorage me jaane se pehle usme skip_onboarding merge kar dete hain.
export const withSkipOnboarding = (extraData) => {
  let parsed = {};
  try {
    parsed = extraData ? JSON.parse(extraData) : {};
  } catch (ex) {
    parsed = {};
  }
  return JSON.stringify({ ...parsed, skip_onboarding: true });
}

export const updateUserToken = () => {
  if (localStorage.getItem('authToken')) {
    const token = localStorage.getItem('authToken');
    localStorage.setItem('access_token', token);
    localStorage.removeItem('authToken');
  }
}


export function setCookie(name, value) {
  var expires = "";
  var date = new Date();
  date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
  expires = "; expires=" + date.toUTCString();
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

export const isValidCharacter = (txtTitle) => {
  var regExp = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  var length = txtTitle.trim().length;
  if (regExp.test(txtTitle)) {
    return 2;
  } else if (length == 0) {
    return 3;
  } else {
    return 1;
  }
};


export const ERROR_ERROR = {
  1: "@",
  2: "#",
  3: "List ",
  4: "@",
  5: "Advanced ",
  6: "Location ",
  7: "@",
  8: "Page ",
  9: "Page ",
  10: "Group ",
  11: "Playlist ",
  12: "Board ",
  13: "URL ",
  14: "Event ",
  16: "Mention ",
  22: "Workplace ",
  23: "@",
  24: "@",
  25: "@",
  26: "#",
  65: "Album",
  67: "Page",
  53: "Group ",
  54: "Topic ",
  55: "Page",
  33: "Place ",
  63: "Search ",
  64: "Sticker ",
};

export const replaceDomain = (url) => {
  let updateUrl = url.replace("Id:", "Id/");
  updateUrl = updateUrl.replace(`${HOST_URL}`, "");
  return updateUrl.includes("widget")
    ? updateUrl.replace(`widget/`, "")
    : updateUrl.includes("display")
      ? updateUrl.replace(`display/`, "")
      : updateUrl;
};



export const TIKTOK_UPDATE_STATUS = async (postId) => {

  const { userData } = store.getState().authenticated;
  const { listData, details } = store.getState().moderation;
  const postData = listData.length > 0 ? listData.filter((val) => val.id == postId) : []
  const url = details?.wall?.url;

  return axios.post(`${EXPIRE_POST_UPDATE}`, {
    wallId: localStorage.getItem('wallId'),
    ownerId: localStorage.getItem('ownerId'),
    postId: postId,
    table_name: userData.UserPlan.db_table,
    feedId: postData.length > 0 ? postData[0].feedId : '',
    type: postData.length > 0 ? postData[0].type : '',
    link: postData.length > 0 ? postData[0].link : '',
    postFile: postData.length > 0 ? postData[0].postFile : '',
    mediaFile: postData.length > 0 ? postData[0].mediaFile : '',
    url: url
  })
}


export const DEBOUNCE = (callback) => {
  let timer;
  return (...args) => {
    if (timer !== null) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        callback(...args)
      }, 600)
    }
  }
}

export const generateSocialName = (feed) => {
  var socialName = '';
  var name = feed.name;
  var prefix = "";
  if (String(name).includes("@")) {
    name = String(name).replace("@", " ");
  }
  if ([1, 2, 19].includes(feed.networkId)) {
    if (String(name).includes("#")) {
      name = String(name).replace("#", " ");
    }
  }



  switch (feed.networkId) {
    case 7:
      if (feed.filterId == 4 || feed.filterId == 32) {
        prefix = ""
        socialName += ' - Keywords';
      }
      break;
    case 19:
      prefix = ""
      if (feed.value3 != "") {
        name = `${name} (${feed.value3})`
      }
      break;
    case 1:
      if (feed.filterId == 7) {
        prefix = "@"
      }
      else if (feed.filterId == 4) {
        socialName += ' - Likes';
      }
      break;
    case 29:
      name = "SnapUp";
      prefix = "";
      break;
    case 18:
      if (feed.filterId == 33) {
        prefix = "";
      }
      break;
    case 10:
      if (feed.value3 == 0 || feed.value3 == 1) {
        socialName += ' - Company';
      }
      else if (feed.value3 == 2) {
        socialName += ' - Job';
      }
      break;

    default:
      break;
  }

  prefix = feedsNetworksPrefix(feed.filterId);
  socialName += `${prefix} ${(name && String(name).length > 0) ? name : feed.value1}`;

  switch (feed.filterId) {
    case 23:
      socialName += ' - Handle';
      break;
    case 24:
    case 62:
      socialName += ' - Mention';
      break;
    case 7:
      if (feed.networkId == 1) {
        socialName += ' - Mention';
      }
      break;

    case 25:
      socialName += ' - Tagged';
      break;

    case 34:
      socialName += ' - Story';
      break;

    case 8:
      socialName += ' - Page';
      break;

    case 66:
      socialName += ' - Videos';
      break;

    case 65:
      socialName += ' - Albums';
      break;

    case 63:
      socialName += ' - Sticker';
      break;

    case 74:
      socialName += ' - Reels';
      break;

    case 29:
      socialName += ' - My Places';
      break;

    case 55:
      socialName += ' - Page Reviews';
      break;

  }

  return socialName;

}


export const feedsNetworksPrefix = (filterID) => {

  switch (filterID) {
    case 1:
      return `@`
      break;
    case 2:
      return `#`
      break;
    case 3:
      return `<i className="fa fa-list-ul"></i>`
      break;
    case 4:
      return `@`
      break;
    case 5:
      return `<i className="fa fa-cog"></i>`
      break;
    case 6:
      return `<i className="fa fa-map-marker"></i>`
      break;
    case 7:
      return `@`
      break;
    case 8:
      return ``
      break;
    case 9:
      return ``
      break;
    case 10:
      return `<i className="fa fa-users"></i>`
      break;
    case 11:
      return `<i className="fa fa-list-ul"></i>`
      break;
    case 12:
      return `<i className="fa fa-th-large"></i>`
      break;
    case 13:
      return `<i className="fa fa-link"></i>`
      break;
    case 14:
      return ``
      break;
    case 16:
      return ``
      break;
    case 22:
      return ``
      break;
    case 23:
      return `@`
      break;
    case 24:
      return `@`
      break;
    case 25:
      return `@`
      break;
    case 26:
      return `#`
      break;
    case 27:
      return `<i className="fa fa-star" aria-hidden="true"></i>`
      break;
    case 28:
      return ``
      break;
    case 32:
      return `<i className="fa fa-map-marker"></i>`
      break;
    case 33:
      return `<i className="fa fa-map-marker"></i>`
      break;
    case 34:
      return `@`
      break;
    case 53:
      return `<i className="fa fa-users"></i> `
      break;
    case 54:
      return `<i className="fa fa-comments-o"></i> `
      break;
    case 55:
      return `<i className="fa fa-star" aria-hidden="true"></i>`
      break;
    case 56:
      return `<i className="fa fa-star" aria-hidden="true"></i>`
      break;
    case 57:
      return `<i className="fa fa-music" aria-hidden="true"></i>`
      break;
    case 58:
      return `<i className="fa fa-video-camera" aria-hidden="true"></i>`
      break;
    case 59:
      return `<i className="fa fa-music" aria-hidden="true"></i> `
      break;
    case 61:
      return `<i className="fa fa-user" aria-hidden="true"></i>`
      break;
    case 62:
      return `@`
      break;

    default:
      return ``
      break;
  }
}


export const getURLFromVideo = (mediaFile) => {
  try {
    var mediaUrl = mediaFile
    if (mediaFile) {
      var videos = mediaFile;
      var videoSrc = mediaFile;
      if (mediaFile.match(/src\=([^\s]*)\s/)) {
        videoSrc = mediaFile.match(/src\=([^\s]*)\s/)[1];
        videos = mediaFile.match(/src\=([^\s]*)\s/)[1];

      }

      if (videoSrc.indexOf("cloud.taggbox.com") == -1) {
        videoSrc =
          "https://images.taggbox.com/" +
          videoSrc.substring(1, videoSrc.length - 1);
      } else {
        videoSrc = videoSrc.substring(1, videoSrc.length - 1);
      }
      mediaUrl = videos.substring(1, videos.length - 1);
      return mediaUrl
    }
    else {
      return mediaUrl
    }
  }
  catch (ex) {
    return mediaFile
  }
}

export const validateUserPicture = (src) => {

  if (src.includes('uploaded')) {
    if (!src.includes(`https://cloud.socialwalls.com/`)) {
      return `https://cloud.socialwalls.com/${src}`;
    }
    return src;
  }
  return src;
}

export const networkIcon = (iconClass) => {
  return `<i className="fab ${iconClass}"></i> `
}


export const VALIDATE_URL = (value) => {
  let url;
  try {
    url = new URL(value);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
};

export const ugcRightExtractDetails = (networkId, responseData, callback) => {
  let name = "";
  let avatar = "";

  if (responseData && Object.keys(responseData).length > 0) {
    if (networkId == 8) {
      const { user } = responseData;
      if (user && Object.keys(user).length > 0) {
        name = user.name;
        avatar = user.pictures.base_link;
      }
    } else if (networkId == 1) {
      const { data } = responseData;
      if (data && Object.keys(data).length > 0) {
        name = data.username;
        avatar = data.profile_image_url;
      }
    } else if (networkId == 2) {
      if (responseData && Object.keys(responseData).length > 0) {
        name = responseData.username;
        avatar = `https://ui-avatars.com/api/?name=${responseData.username}&background=0a63dc&color=fff&length=1`;
      }
    } else if (networkId == 3 || networkId == 18) {
      if (responseData && Object.keys(responseData).length > 0) {
        name = responseData.name;
        avatar = `https://ui-avatars.com/api/?name=${responseData.name}&background=0a63dc&color=fff&length=1`;
        if (responseData.picture && Object.keys(responseData.picture).length > 0 && responseData.picture.data && Object.keys(responseData.picture.data).length > 0) {
          avatar = responseData.picture.data.url;
        }
      }
    } else if (networkId == 11) {
      name = responseData.name;
      avatar = responseData.blogs.length > 0 ? responseData.blogs[0].avatar[0].url : '';
    } else if (networkId == 21) {
      name = responseData.username;
      avatar = responseData.picture;
    } else {
      name = responseData.username;
      avatar = responseData.picture;
    }
  } else if (networkId == 1) {
    const { details } = responseData;
    name = details.username;
    avatar = details.image;
  }
  else if (networkId == 3 || networkId == 18) {
    if (responseData && responseData.length > 0) {
      name = responseData[0].accountName;
      avatar = responseData[0].profile_image_url;
    }
  } else if (networkId == 11) {
    name = responseData.name;
    avatar = responseData.blogs.length > 0 ? responseData.blogs[0].avatar[0].url : '';
  } else if (networkId == 21) {
    name = responseData.username;
    avatar = responseData.picture;
  } else if (networkId == 2) {
    name = responseData.username;
    avatar = responseData.profile_image_url;
  }
  setCookie(`ugcAuthorisedAvatar${networkId}`, avatar);
  setCookie(`ugcAuthorisedName${networkId}`, name);
  callback(name, avatar);
}

export const downloadHtml = (filename, text) => {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

export const breakRow = (text) => {
  return ReactHtmlParser(text.replace(/\r?\n/g, '<br/>'))
}

export const isAppleSafari = () => {
  const appleExpression = /Apple/i;
  const safariExpression = /Safari/i;
  return appleExpression.test(navigator.vendor) &&
    safariExpression.test(navigator.userAgent);
};


export const OverviewChartFormatting = (formattingData) => {
  let data = [];
  if (formattingData && formattingData.length > 0) {
    formattingData.map((item) => {
      data.push({
        name: item.name,
        type: 'line',
        data: dataConvertToInt(item.data)
      })
    })
    return data;
  }
  else return formattingData;
}


export const dataConvertToInt = (formateIntData) => {
  let updateData = [];
  if (formateIntData && formateIntData.length > 0) {
    formateIntData.map((item) => {
      updateData.push(parseInt(item))

    })
    return updateData


  }
  else return formateIntData

}

export const iniFrame = () => {
  if (window.self !== window.top) return true
  else return false
}

export const encrypt = (value) => {
  const cipherText = crypto.AES.encrypt(value, ENCRYPTION_KEY).toString();
  return cipherText;
};

export const decrypt = (cipherText) => {
  const bytes = crypto.AES.decrypt(cipherText, ENCRYPTION_KEY);
  const plainText = bytes.toString(crypto.enc.Utf8);
  return plainText;
};

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const resturctureCloudPath = (fileName, path = null) => {
  const uppyTempPath = `${UPPY_BUCKET_URL}media/tmpimages`;
  if (!fileName || fileName == "") {
    return "";
  } else if (fileName.includes('cloud.socialwalls.com') || fileName.includes('cloud.socialwalls.com') || fileName.includes('cloud.taggbox.com') || fileName.includes('cloud.tagbox.com')) {
    return fileName;
  } else if (fileName.includes('media/tmpimages/')) {
    return `${UPPY_BUCKET_URL}${fileName}`;;
  } else if (path == null) {
    return `${uppyTempPath}/${fileName}`;
  } else {
    return `${path}${fileName}`;
  }
}

// Legacy Social Walls logo assets still stored against older walls - always
// resolve them to the current CDN logo instead of the retired file.
const LEGACY_SW_LOGOS = ['logos/social-wall-logo-old.svg'];

export const getDefaultLogo = (logo) => {
  if (!logo) return null;
  // Already an absolute URL (CDN assets, etc.) - keep it as is, don't prefix the cloud path.
  const logoPath = /^https?:\/\//i.test(logo)
    ? logo
    : `${resturctureCloudPath(logo, 'https://cloud.taggbox.com/')}`;
  return LEGACY_SW_LOGOS.some((legacy) => logoPath.includes(legacy)) ? SW_LOGO : logoPath;
}

export const isJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export const SENTIMENTS_CALC = event => {

  if (event >= 80) {
    return {
      item: '1',
      label: 'Strongly Positive'
    }
  } else if (event >= 50 && event < 80) {
    return {
      item: '2',
      label: 'Positive'
    }
  } else if (event >= 30 && event < 50) {
    return {
      item: '3',
      label: 'Neutral'
    }
  } else if (event >= 10 && event < 30) {
    return {
      item: '4',
      label: 'Negative'
    }
  } else if (event >= 0 && event < 10) {
    return {
      item: '5',
      label: 'Strongly Negative'
    }
  }
}

export const PREPEND_ZERO = E => E < 9 ? 0 === E ? 0 : "0" + E : E;

export const hideLangFilter = (feedList, languageFeeds, status = 0) => {

  return feedList.reduce((acc, curr) => {
    if (languageFeeds.split(',').includes(String(status ? curr : curr.id))) acc = true;
    return acc;
  }, false);
}


export const reArrangeSeriesData = (data) => {

  const series = [];
  const newSeries = [];
  const labels = [];
  let maxIndex = 0

  if (data) {
    for (let i = 0; i < data.length; i++) {
      const seriesItem = data[i]['screenName'];
      const activeHours = data[i]['activeHours'];

      const labelIndex = parseInt(activeHours, 10);

      newSeries.push(seriesItem);
      labels.push(labelIndex);
      series.push(activeHours);

      maxIndex = labelIndex > maxIndex ? labelIndex : maxIndex
    }
  }




  maxIndex = labels.indexOf(Math.max(...labels));
  return { newSeries, labels, series, maxIndex };
}


export const reArrangeSeriesSentiment = (data, status = 0) => {
  const newSeries = [];
  const newDate = [];
  const unixDate = [];

  data = status == 3 || status == 1 ? data.filter((_, index) => index !== status) : data;

  const { currency } = data;
  const series = data;
  const labels = data[0]['labels'];
  const targetTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  let dateFormat = 0

  if (data) {

    for (let i = 0; i < series.length; i++) {
      const seriesItem = series[i];
      const newData = [];

      for (let j = 0; j < labels.length; j++) {
        if (seriesItem.data[j]) {
          newData.push([moment.unix(seriesItem.labels[j]).tz(targetTimeZone), seriesItem.data[j]]);
          unixDate.push(moment.unix(seriesItem.labels[j]).tz(targetTimeZone));
        }
      }

      newSeries.push({ name: seriesItem.name, data: newData });
    }
  }

  if (labels) {
    labels.forEach(dateStr => {
      newDate.push(moment.unix(dateStr, dateFormat ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY").format(dateFormat ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY"));
    });
  }

  return { newSeries, newDate, unixDate, currency };
}


export const reArrangeSeries = (data, status = 0, zeroPost = 0) => {
  const newSeries = [];
  const newDate = [];
  const unixDate = [];

  data = status == 3 || status == 1 ? data.filter((_, index) => index !== status) : data;


  const { currency } = data;
  const series = data;
  const labels = data[0]['labels'];
  let dateObj = ""
  let dateFormat = 0


  if (data) {

    for (let i = 0; i < series.length; i++) {
      const seriesItem = series[i];
      const newData = [];

      for (let j = 0; j < labels.length; j++) {

        if (seriesItem.data[j] || zeroPost) {

          if (labels[j].includes(':')) {
            const getDate = labels[j].split(' ');
            const [day, month, year] = getDate[0].split('/').map(Number);
            const [hours, min] = getDate[1].split(':').map(Number);
            dateObj = new Date(year, month - 1, day + 1, hours, min);
            dateFormat = 1
          } else {
            const [day, month, year] = labels[j].split('/').map(Number);
            dateObj = new Date(year, month - 1, day + 1);
          }


          const unixTimestamp = dateObj.getTime();
          newData.push([unixTimestamp, seriesItem.name == "Total Posts" ? Math.round(seriesItem.data[j]) : seriesItem.data[j]]);
          unixDate.push(unixTimestamp);
        }
      }
      newSeries.push({ name: seriesItem.name, data: newData });
    }
  }

  if (labels) {
    labels.forEach(dateStr => {
      newDate.push(moment(dateStr, dateFormat ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY").format(dateFormat ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY"));
    });
  }

  return { newSeries, newDate, unixDate, currency };
}


export const getFlagCode = (value, flags) => {

  let valueToSearch = value.toLowerCase();
  const item = flags.find(flag => (flag.value.toLowerCase() == valueToSearch || flag.value.toLowerCase().includes(valueToSearch)));
  return (value == 'Aragonese' || value == 'Asturian') ? 'es' :
    value == 'Breton' || value == 'French' || value == 'Interlingua' || value == 'Occitan' ? 'fr' :
      value == 'Central Kurdish' ? 'iq' :
        value == 'Faroese' ? 'de' :
          value == 'Norwegian Bokm' || value == 'Norwegian Nynorsk' ? 'no' :
            value == 'Romansh' ? 'ch' :
              value == 'Serbo' ? 'rs' :
                value == 'Southern Sotho' ? 'za' :
                  value == 'Tagalog' ? 'ph' :
                    value == 'Tongan' ? 'nz' :
                      value == 'Walloon' ? 'be' :
                        value == 'Western Frisian' ? 'de' :
                          item ? item.code.toLowerCase() : ''
}

export const manageSpace = (value) => {
  return value.replace(/\s+/g, '_')
}

export const getFirstLetterOfString = (str) => {
  return str ? str.replace(/[^a-zA-Z]/g, '').charAt(0) : null;
}

export const getthemeLayout = (id) => {
  return [62, 63, 64.65, 78].includes(id)
    ? "waterfall"
    : [66, 67, 68.65, 69].includes(id)
      ? "grid"
      : [70, 71, 73].includes(id)
        ? "carousel"
        : "slideshow"
}


export const checkUrlSlugAndSlash = (url) => {
  try {
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname;

    // Check if the pathname has a trailing slash and if it has a slug (a path part)
    const hasTrailingSlash = pathname.endsWith('/');
    const hasSlug = pathname.split('/').filter(Boolean).length > 0; // Checks if there are non-empty path segments

    return { hasTrailingSlash, hasSlug };
  } catch (e) {
    console.error("Invalid URL", e);
    return { hasTrailingSlash: false, hasSlug: false };
  }
}


export const DOWNGRADE_UPDATE_SOCKET = (navigate) => {
  if (!window.location.href.includes('accounts/login') && checkUrlSlugAndSlash(window.location.href).hasSlug) {
    const userId = localStorage.getItem('ownerId');

    SOCKET_CONNECTION.on('downgrade' + userId, function (response) {
      const { id, isfree } = response;
      if (id != '' && id == userId) {
        store.dispatch(getProductAndPlanDetails());
        store.dispatch(getUserInfo(navigate, false, false, true, isfree ? 'isUpgrade' : null));
      }
    });

    SOCKET_CONNECTION.on('update' + userId, function (data) {
      new HttpClient().post(UPDATE_USER_PLAN, { type: getInitialRoute() != 'widget' ? 4 : 6 }).then((response) => {
        if (data.plan != '') {
          Swal.fire({
            title: "Plan Upgrade",
            text: "Your " + data.plan + " successfully updated.",
            icon: "success",
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false
          })
        }
        if (data.plan != '') {
          store.dispatch(getUserInfo(navigate, false, false, true));
        }
        store.dispatch(getProductAndPlanDetails());
      }).catch(ex => {

      });
    });
  }
}



export const SOCKET_CONNECTION = io(`${SOCKET_CLIENT_URL}`, { transports: ["websocket"], transport: ["websocket"], upgrade: true, reconnection: true, reconnectionDelay: 3000, reconnectionDelayMax: 5000, reconnectionAttempts: 2 });

// ---------- Not Using------

export const getflagCode = (value) => {
  let valueToSearch = value.toLowerCase();
  const item = this.state.flags.find(flag => (flag.value.toLowerCase() == valueToSearch || flag.value.toLowerCase().includes(valueToSearch)));
  return value == 'French' ? 'fr' : item ? item.code.toLowerCase() : '';
}


export const isRefresh = (item) => {
  if ([3, 5].includes(item?.type)) {
    return true
  }
  return false
}


export const MEDIA_REPLACE_URL = s => s && String(s) && String(s).includes("cloud.tagbox.com.s3.us-west-1.wasabisys.com") ? String(s).replace("cloud.tagbox.com.s3.us-west-1.wasabisys.com", "cloud.tagbox.com") : s;


export const RECOMMENDATION_CALC = event => {
  if (event > 70) {
    return {
      classN: 'success',
      label: 'Recommended'
    }
  } else if (event > 35 && event < 70) {
    return {
      classN: 'warning',
      label: 'Considerable'
    }
  } else {
    return {
      classN: 'danger',
      label: 'Not Recommended'
    }
  }
}


export const stringEncryption = (action, str) => {
  let encoded = '';
  str = btoa(str);
  str = btoa(str);
  for (let i = 0; i < str.length; i++) {
    let a = str.charCodeAt(i);
    let b = a ^ 10; // bitwise XOR with any number, e.g. 123
    encoded = encoded + String.fromCharCode(b);
  }
  encoded = btoa(encoded);
  return encoded;
}

export const openPublishPopup = () => {
  var publishTag = document.querySelector(".publish_type");
  publishTag.style.display = "block";
};


export const geturlParm = () => {
  const url = window.location.pathname;
  const array = url.split("/");
  return array;
};

export const getCookie = (name) => {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const GET_NETWORK_COLOR = (networkId) => {
  switch (networkId) {
    case 0:
      return "#313A53"
      break;
    case 1:
      return "#29a9e1"
      break;
    case 2:
      return "#e2306c"
      break;
    case 3:
      return "#1b74e4"
      break;
    case 4:
      return "#4081ed"
      break;
    case 5:
      return "#e60022"
      break;
    case 6:
      return "#0a63dc"
      break;
    case 7:
      return "red"
      break;
    case 8:
      return "#1eb8eb"
      break;
    case 10:
      return "#0a66c2"
      break;
    case 11:
      return "#36465d"
      break;
    case 12:
      return "#f78422"
      break;
    case 13:
      return "#FABF04"
      break;
    case 15:
      return "#4767ab"
      break;
    case 18:
      return "#e2306c"
      break;
    case 19:
      return "#be362e"
      break;
    case 20:
      return "#510d4e"
      break;
    case 21:
      return "#0078d4"
      break;
    case 23:
      return "#ff7977"
      break;
    case 25:
      return "#f50"
      break;
    case 26:
      return "#000"
      break;
    case 27:
      return "#00e59b"
      break;
    case 28:
      return "#000"
      break;
    case 29:
      return "#613983"
      break;
    case 30:
      return "#613983"
      break;
    case 31:
      return "#fff4de"
      break;
    case 32:
      return "#000"
      break;
    default:
      return ""
      break;
  }
}

export const onRedirectToModration = (id, wallId, navigate) => {
  if (id === 0) {
    navigate(`/widget/moderation/index/${wallId}`);
  } else {
    navigate(`/widget/moderation/index/${wallId}#${id}`);
  }
};


export const getWallIDs = (wallData) => {
  let feedIDs = [];
  if (wallData && wallData.length > 0) {
    wallData.map((fItem) => { feedIDs.push(fItem.value || fItem.id); });
  }
  return feedIDs?.join(',')
}

export const generateRandomArray = (length) => Array.from({ length: length }, (_, i) => i + 1)

export const getImageSize = (imgUrl) => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };

    img.onerror = (error) => {
      reject(new Error(`Failed to load image at ${imgUrl}`));
    };

    img.src = imgUrl;
  });
};

export const HANDLE_IMAGE_ERROR = (event, isProduct, handleAllImageError) => {
  const src = event.target.src;
  if (src === ErrImg || src === ProductPlaceholder || src.includes('cloud.socialwalls.com')) return;

  if (handleAllImageError) {
    handleAllImageError(event);
  }
  event.target.src = isProduct ? ProductPlaceholder : ErrImg;
};


export const GET_NETWORK_NAME = (e) => networksMap[e]?.networkname || "";


export const POPUP_VIDEO_RENEW = async (e, callBack = () => { }) => {
  try {
    const { target } = e;
    if (target?.src?.includes('https://cloud.socialwalls.com')) return;

    const attrs = ["data-network", "data-item-id", "data-filter-id", "data-stories", "data-load"];
    const [network, postId, filterId, dataStories, dataLoad] = attrs.map(attr => target.getAttribute(attr));
    const { userData } = store.getState().authenticated;
    const refreshPostId = document.querySelector(`.refresh_post_media_Popup${postId}`);
    if (network) {
      if (dataLoad != 1 && filterId != "34" && dataStories == 0) {
        new HttpClient().post(`${EXPIRE_POST_UPDATE}`, {
          wallId: localStorage.getItem('wallId'),
          postId: postId,
          // table_name: userData.UserPlan.db_table,
          // ownerId: localStorage.getItem('ownerId'),
          // model: "wall"
        }).then(({ data }) => {
          e.target.src = data.video;
          e.target.setAttribute("autoplay", true)
          e.target.setAttribute("loop", true)
          e.target.setAttribute("data-load", "1")
          document.querySelector(`.refresh_post_media_Popup${postId}`)?.setAttribute('style', 'display:block !important')
          callBack(data.video)
        })
          .catch((error) => {
            e.target.setAttribute("data-load", "1")
            refreshPostId?.setAttribute('style', 'display:block !important')
            callBack()
          })
      }
      else {
        e.target.setAttribute("data-load", "1")
        refreshPostId?.setAttribute('style', 'display:block !important')
      }

    }
  } catch (error) {
    console.error("Error in IMG_LOAD_AFTER_COMPLETE_LAYOUT_FOR_POP_UP_VIDEO: ", error);
  }
}



export const POPUP_IMAGE_RENEW_REQUEST = async (e, callback = () => { }) => {
  e.persist()

  const { target } = e;
  const attrs = ["data-network", "data-id", "data-load"];
  const [network, postId, dataLoad] = attrs.map(attr => target.getAttribute(attr));
  const { userData } = store.getState().authenticated;
  const refreshPostId = document.querySelector(`.refresh_post_media_${postId}`);

  if (network && dataLoad != 1) {
    new HttpClient().post(`${EXPIRE_POST_UPDATE}`, {
      wallId: localStorage.getItem('wallId'),
      postId: postId,
      // table_name: userData?.UserPlan.db_table,
      // ownerId: localStorage.getItem('ownerId'),
      // model: "wall"
    }).then(({ data: { code, media } }) => {
      if (code === 200 && media) {
        e.target.src = media;
        e.target.setAttribute("data-load", "1")
        store.dispatch({ type: MOD_PST_FILE_UPDATE, payload: { id: Number(postId), postFile: media } })
      }
      else {
        e.target.src = ErrImg;
        e.target.setAttribute("data-load", "1")
        refreshPostId?.setAttribute('style', 'display:block !important')
      }
      callback()
    })
      .catch((error) => {
        e.target.src = ErrImg;
        e.target.setAttribute("data-load", "1")
        refreshPostId?.setAttribute('style', 'display:block !important')
        callback()
      })
  }
  else {
    e.target.src = ErrImg;
    callback()
  }
}


export const copyToClipboard = (id) => {
  const el = document.getElementById(id);
  el && navigator.clipboard.writeText(el.textContent).catch(console.error);
};


export const networksMap = {
  0: { networkId: 0, networkname: "Manual Upload", networkCode: "manual-upload" },
  1: { networkId: 1, networkname: "Twitter", networkCode: "twitter" },
  2: { networkId: 2, networkname: "Instagram", networkCode: "instagram" },
  3: { networkId: 3, networkname: "Facebook", networkCode: "facebook" },
  4: { networkId: 4, networkname: "Google Reviews", networkCode: "google" },
  5: { networkId: 5, networkname: "Pinterest", networkCode: "pinterest" },
  6: { networkId: 6, networkname: "Flickr", networkCode: "flickr" },
  7: { networkId: 7, networkname: "YouTube", networkCode: "youtube" },
  8: { networkId: 8, networkname: "Vimeo", networkCode: "vimeo" },
  18: { networkId: 2, networkname: "Instagram", networkCode: "instagram-business" },
  23: { networkId: 23, networkname: "Airbnb Reviews", networkCode: "airbnb" },
  28: { networkId: 28, networkname: "TikTok", networkCode: "tiktok" },
  29: { networkId: 29, networkname: "SnapUp", networkCode: "onsiteupload" },
  33: { networkId: 33, networkname: "Collab with Creators", networkCode: "collab-with-creators" }
};
export const isPersAcc = (id) => [1, 34, 25, 66].includes(id); // to check if the filterId belongs to personal Instagram
export const isFbHashtagFilter = (networkId, filterId) => networkId == 3 && filterId == 2; // Facebook Hashtag requires custom setup, not a self-serve form
export const isOnboardingPremiumNetwork = (networkId) => networkId == 4; // Google Reviews is Enterprise-only during onboarding, not a self-serve form
export const isAccountConnected = ({ connectedAcc, accountList, accountId, connetedAccount }) =>
    Boolean((connectedAcc && connectedAcc.length > 0) || (accountList && accountList.length > 0) || accountId || connetedAccount);
export const handleCatchError = (error) => TOAST_ERROR(error?.response?.data?.responseMessage || 'An error occurred. Please try again later.');
export const addIntercomMsg = (msg) => { if (window?.Intercom) window.Intercom('showNewMessage', msg); }

export const setIntercomData = (IntercomData) => {
  if (window.location.href.includes('app.') && !localStorage.getItem('Isadmin') && IntercomData && Object.keys(IntercomData).length > 0) {
    window.intercomSettings = IntercomData;
    // hold the boot until the pending email-verification popup is dismissed via "Let's Go" (see bootPendingIntercom)
    if (getCookie('emailConfirmation') == 'true') window.pendingIntercomSettings = IntercomData;
    else { window.Intercom('shutdown'); window.Intercom('boot', IntercomData); }
  }
}

// anonymous (visitor) chat for logged-out pages such as login / register
export const bootGuestIntercom = () => {
  if (window.Intercom && !localStorage.getItem('Isadmin') && !localStorage.getItem('access_token')) window.Intercom('boot', { app_id: window.APP_ID || 'veiaqij8', action_color: '#ffffff' });
}

export const shutdownGuestIntercom = () => {
  if (window.Intercom && !localStorage.getItem('access_token')) window.Intercom('shutdown');
}

export const bootPendingIntercom = () => {
  if (window.pendingIntercomSettings) {
    window.Intercom('boot', window.pendingIntercomSettings);
    window.pendingIntercomSettings = null;
  }
}

export const downloadElement = (filename, content, type) => {
  const element = document.createElement('a');
  let dataUrl = '';
  if (type == "html") {
    dataUrl = 'data:text/plain;charset=utf-8,' + encodeURIComponent(content);
  } else if (type == "canvas") {
    dataUrl = content.toDataURL('image/png');
  }

  element.setAttribute('href', dataUrl);
  element.setAttribute('download', filename);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

export const CalendlyPop = ({ show, hidePop, url = null }) => {
  return <Modal className="discuss-modal" show={show} onHide={hidePop} backdrop="static" keyboard={false} aria-labelledby="contained-modal-title-vcenter" centered size="xl">
    <Modal.Body>
      <iframe src={url || "https://calendly.com/taggbox/demo?embed_domain=app.socialwalls.com&embed_type=PopupText"} style={{ width: '100%', height: "700px" }} title="calendly"></iframe>
      <div className="custom-close">
        <a className="close-btn-iframe text-white" onClick={hidePop}><i class="fas fa-times"></i></a>
      </div>
    </Modal.Body>
  </Modal>
}

export const checkInvoiceData = (datetoParse, format) => {
  const isValidDate = String(datetoParse).includes("/") ? moment(datetoParse, "MM/DD/YYYY", true) : moment(datetoParse);
  if (isValidDate.isValid()) {
    const parsedDate = isValidDate.format(format);
    return parsedDate;
  }
  return datetoParse;
}

export const parseNumber = (num) => (num && !isNaN(num)) ? Number(num) : 0;

export const parseStringObj = (data) => {
  try {
    return typeof data === 'object' && data !== null
      ? data
      : JSON.parse(data);
  } catch {
    return data;
  }
};

export const getFeedCount = (netId, filId, feeds) => {
  return feeds.reduce((acc, curr) => {
    if (curr.networkId == netId && curr.filterId == filId) acc++;
    return acc;
  }, 0) || 0
}

// Global function to convert JSON array to CSV and download it
export const downloadJSONAsCSV = (data, filename = "data.csv") => {
  if (!data || !data.length) {
    console.error("Invalid or empty data provided");
    return;
  }

  // Extract headers
  const header = Object.keys(data[0]).map(h => capitalizeFirstLetter(h ?? "")).join(",");

  // Extract rows
  const rows = data.map(obj =>
    Object.values(obj)
      .map(val => `"${String(val).replace(/"/g, '""')}"`) // handle quotes
      .join(",")
  );

  // Build CSV string
  const csvContent = [header, ...rows].join("\n");

  // Create downloadable blob
  const blob = new Blob([csvContent], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);

  // Trigger download
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export function isOldUser(timestamp, date = '01/25/26') {
  const inputDate = new Date(timestamp * 1000);
  const today = new Date(date);

  inputDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  return inputDate < today;
}


export const loadLanguage = async (language, onsite_language) => {
  try {
    const response = await fetch(
      `${MediaBaseUrl}custom_lang.json?v=1.5`
    );

    const data = await response.json();

    return data[language || onsite_language || "english"];
  } catch (error) {
    console.error("Error fetching JSON file:", error);
    return null;
  }
};




export const SESSION_TOKEN_COOKIE = "session_token";

export const deleteCookie = (name) => {
  const expires = "; expires=Thu, 01 Jan 1970 00:00:00 GMT";
  const parts = window.location.hostname.split(".");
  const domains = [""];
  for (var i = 0; i < parts.length - 1; i++) {
    const domain = parts.slice(i).join(".");
    domains.push(`; domain=${domain}`, `; domain=.${domain}`);
  }
  const paths = ["/"];
  var current = "";
  window.location.pathname.split("/").filter(Boolean).forEach((segment) => {
    current += `/${segment}`;
    paths.push(current);
  });
  paths.forEach((path) => {
    domains.forEach((domain) => {
      document.cookie = `${name}=${expires}; path=${path}${domain}`;
    });
  });
};

export const setTokenFromWebsiteCookie = () => {
  const sessionToken = getCookie(SESSION_TOKEN_COOKIE);
  if (!sessionToken) return false;

  var token = sessionToken;
  try {
    token = decodeURIComponent(sessionToken);
  } catch (ex) {
    token = sessionToken;
  }

  localStorage.setItem("access_token", token);
  deleteCookie(SESSION_TOKEN_COOKIE);

  // cookie can belong to a domain/path we are not allowed to clear, so reload only once
  if (getCookie(SESSION_TOKEN_COOKIE)) {
    if (sessionStorage.getItem("websiteSessionApplied")) return false;
    sessionStorage.setItem("websiteSessionApplied", "1");
  }
  return true;
};
